import { getFormElementAPI } from '../../utils/form_element_api_builder';

let behaviorsEventsSubscriptions = [];

export const subscribe = (formAPI, eventHandler) => {
	const formBehaviors = formAPI.behaviors();

	unsubscribeFromPreviousBehaviorsEvents();
	formBehaviors.forEach(subscribeToBehaviorEvents.bind(this, formAPI, eventHandler));
};

const unsubscribeFromPreviousBehaviorsEvents = () => {
	behaviorsEventsSubscriptions.forEach((s) => s.unsubscribe());
};

const subscribeToBehaviorEvents = (formAPI, eventHandler, behavior) => {
	const { events } = behavior;
	if(Array.isArray(events) && events.length > 0) {
		events.forEach(subscribeBehaviorToEvent.bind(this, formAPI, eventHandler, behavior));
	}
};

const subscribeBehaviorToEvent = (formAPI, eventHandler, behavior, behaviorEvent) => {
	const behaviorElementAPI = getBehaviorElementAPI(formAPI, behaviorEvent);
	const eventName = behaviorEvent.event;
	if(behaviorElementAPI){
		behaviorsEventsSubscriptions.push(
			behaviorElementAPI.subscribe(eventName, eventHandler.bind(this, formAPI, behavior, eventName))
		);
	}
};

const subscribeBehaviorToAllFormEvents = (formAPI, eventHandler, behavior) => {
	behaviorsEventsSubscriptions.push(
		formAPI.subscribeToAll(eventHandler.bind(this, formAPI, behavior))
	);
};

const getBehaviorElementAPI = (formAPI, behaviorEvent) => {
	const behaviorElementAPI = getFormElementAPI(formAPI, behaviorEvent);
	if(!behaviorElementAPI){
		throw new Error(`form.errors.behavior.event.invalid_element`);
	}

	return behaviorElementAPI;
};

export default {
	subscribe,
};
